export default "__VITE_ASSET__CDN16TOD__"